import { PERMISSIONS, ROLES } from "./permissions";

export const ROLE_LABELS: Record<string, string> = {
  [ROLES.ROLE_ATLETA]: "Atleta",
  [ROLES.ROLE_ADMIN]: "Administrador",
  [ROLES.ROLE_MASTER]: "Master",
  [ROLES.ROLE_ORGANIZADOR]: "Organizador",
  [ROLES.ROLE_USER]: "Usuário operacional",
  [ROLES.ROLE_USER_GER]: "Gerência",
  [ROLES.ROLE_USER_FIN]: "Financeiro",
  [ROLES.ROLE_USER_CRO]: "Cronometragem",
  [ROLES.ROLE_USER_ORG]: "Organizador (operacional)",
};

export const PERMISSION_LABELS: Record<string, string> = {
  [PERMISSIONS.PERMISSION_VIEW]: "Visualizar",
  [PERMISSIONS.PERMISSION_CREATE]: "Criar",
  [PERMISSIONS.PERMISSION_UPDATE]: "Editar",
  [PERMISSIONS.PERMISSION_DELETE]: "Excluir",
  [PERMISSIONS.PERMISSION_FINANCEIRO]: "Financeiro",
  [PERMISSIONS.PERMISSION_DASHBOARD]: "Acesso ao painel",
};

export function labelRole(type: string): string {
  return ROLE_LABELS[type] ?? type.replace("ROLE_", "").replace(/_/g, " ");
}

export function labelPermission(type: string): string {
  return (
    PERMISSION_LABELS[type] ??
    type.replace("PERMISSION_", "").replace(/_/g, " ")
  );
}

/** Roles que não podem ser atribuídas via painel (exceto super admin). */
export const ROLES_PROTECTED = new Set<string>([ROLES.ROLE_MASTER]);

/** Perfis sempre presentes — não podem ser removidos pelo administrador. */
export const ROLES_MANDATORY = new Set<string>([ROLES.ROLE_ATLETA]);

export function isMandatoryRole(type: string): boolean {
  return ROLES_MANDATORY.has(type);
}

export function ensureMandatoryRoleIds(
  selectedIds: string[],
  catalog: Array<{ id: string; type: string }>,
): string[] {
  const mandatoryIds = catalog
    .filter((r) => ROLES_MANDATORY.has(r.type))
    .map((r) => r.id);
  return [...new Set([...selectedIds, ...mandatoryIds])];
}

export function canManageAccess(roles: string[], isSuperAdmin?: boolean): boolean {
  if (isSuperAdmin) return true;
  return roles.includes(ROLES.ROLE_ADMIN);
}

export function computeEffectivePermissions(
  selectedRoleIds: string[],
  catalog: Array<{ id: string; permissions: Array<{ type: string }> }>
): string[] {
  const set = new Set<string>();
  for (const roleId of selectedRoleIds) {
    const role = catalog.find((r) => r.id === roleId);
    role?.permissions.forEach((p) => set.add(p.type));
  }
  return [...set].sort();
}

export function canAccessPanelFromPermissions(permissions: string[]): boolean {
  return permissions.includes(PERMISSIONS.PERMISSION_DASHBOARD);
}
